import { FC } from 'react';
import classNames from 'classnames';
import styles from './glasstapeMark.module.sass';

export interface GlasstapeMarkProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * Glasstape isologo — the lowercase "g" with the half-underline signature.
 * DM Sans 500, monochrome, single gesture. Inherits `color: currentColor`.
 * Glyph for tight spaces (app icon, sidebar, favicon).
 */
export const GlasstapeMark: FC<GlasstapeMarkProps> = ({ size = 24, className, title = 'Glasstape' }) => {
  const fontSize = size * 0.85;
  const barHeight = Math.max(2, size * 0.07);
  const pb = size * 0.14;
  return (
    <span
      className={classNames(styles.mark, className)}
      style={{ width: size, height: size, fontSize }}
      role="img"
      aria-label={title}
    >
      <span className={styles.g} style={{ paddingBottom: pb, letterSpacing: -0.02 * size }}>
        g
        <span className={styles.bar} style={{ height: barHeight }} />
      </span>
    </span>
  );
};

export interface GlasstapeWordmarkProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * Glasstape wordmark — "glasstape" + half underline.
 * DM Sans 500, lowercase. Inherits `color: currentColor`.
 */
export const GlasstapeWordmark: FC<GlasstapeWordmarkProps> = ({ size = 22, className, title = 'Glasstape' }) => {
  const barHeight = Math.max(2, size * 0.07);
  const pb = size * 0.3;
  return (
    <span
      className={classNames(styles.wordmark, className)}
      style={{ fontSize: size }}
      role="img"
      aria-label={title}
    >
      <span className={styles.text} style={{ paddingBottom: pb }}>
        glasstape
        <span className={styles.bar} style={{ height: barHeight }} />
      </span>
    </span>
  );
};

GlasstapeMark.displayName = 'GlasstapeMark';
GlasstapeWordmark.displayName = 'GlasstapeWordmark';
export default GlasstapeMark;
